
import { inject} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { DwUsersActivityService } from './dw-users-activity.service';
import { DwUserActivityTypes } from '../models/dwUsersActivityTypes';

export const DwUsersActivityEventResolver = (route: ActivatedRouteSnapshot) => {
	const dwUsersActivityService: DwUsersActivityService = inject(DwUsersActivityService);

	if (route.data?.dwEvent) {
		dwUsersActivityService.track(route.data.dwEvent, DwUserActivityTypes.ChangeRoute);
	}

	return true;
}
